import { useGroupsContext, useTreeStartingPid } from '@fs/zion-tree-groups'
import { useEffect } from 'react'
import useFocusPerson from '../data-service/useFocusPerson'
import useActiveRole from '../common/useActiveRole'

export default function useGroupOverlay(): void {
  const { focusPerson } = useFocusPerson()
  const { currentTreeId, openGroupOverlay, treeDetails } = useGroupsContext()
  // We don't care about the startingPidData if the current tree is the PRIVATE tree
  const { data: startingPidData, loading: loadingStartingPerson } = useTreeStartingPid(currentTreeId)
  const { role } = useActiveRole()
  const isDataAdmin = !!role

  useEffect(() => {
    if (
      focusPerson?.visibleToAllWhenUsingFamilySearchApps === false &&
      openGroupOverlay &&
      !loadingStartingPerson &&
      !startingPidData?.personId &&
      typeof currentTreeId === 'string' &&
      currentTreeId !== 'PRIVATE' &&
      currentTreeId !== '' &&
      treeDetails &&
      !treeDetails.hidden &&
      !isDataAdmin
    ) {
      openGroupOverlay()
    }
  }, [
    currentTreeId,
    focusPerson?.visibleToAllWhenUsingFamilySearchApps,
    loadingStartingPerson,
    openGroupOverlay,
    startingPidData?.personId,
    treeDetails,
    isDataAdmin,
  ])
}
